import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { blogPosts } from '../../mocks/blogPosts';

export default function ConteudoPage() {
  const categorias = [
    'Todas',
    'Investimento na Flórida',
    'Construção residencial',
    'Mercado imobiliário',
    'Bastidores da obra',
    'Dicas para investidores estrangeiros',
  ];

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="pt-20">
        <section className="bg-white py-24">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="text-center mb-16">
              <h1 className="text-6xl font-bold text-black mb-6">Conteúdo</h1>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Artigos, insights e informações sobre investimento em construção na Flórida, mercado imobiliário e bastidores dos nossos projetos.
              </p>
            </div>

            <div className="flex flex-wrap justify-center gap-3 mb-16">
              {categorias.map((cat) => (
                <button
                  key={cat}
                  className="px-6 py-3 bg-gray-100 text-gray-700 rounded-full font-medium text-sm hover:bg-black hover:text-white transition-all whitespace-nowrap cursor-pointer"
                >
                  {cat}
                </button>
              ))}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {blogPosts.map((post) => (
                <Link
                  key={post.slug}
                  to={`/conteudo/${post.slug}`}
                  className="group cursor-pointer"
                >
                  <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300">
                    <div className="relative h-56 overflow-hidden">
                      <img
                        src={post.imagem}
                        alt={post.titulo}
                        className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-6">
                      <div className="flex items-center justify-between mb-3">
                        <span className="text-xs font-semibold text-gold-500 uppercase tracking-wide">
                          {post.categoria}
                        </span>
                        <span className="text-xs text-gray-500">{post.tempoLeitura}</span>
                      </div>
                      <h3 className="text-xl font-bold text-black mb-3 group-hover:text-gold-500 transition-colors">
                        {post.titulo}
                      </h3>
                      <p className="text-gray-600 leading-relaxed mb-4">{post.resumo}</p>
                      <div className="flex items-center text-sm text-gray-500">
                        <i className="ri-calendar-line mr-2"></i>
                        <span>{post.data}</span>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
